// 日付表示フォーマッタの共通実装。null 安全。内部は Time (JST固定) を使用する。
// util/Time.ts 自体は変更禁止のため、null ガード付きラッパをここに集約する。

import Time from "./Time";

export function formatDate(ts: number | null | undefined): string {
  if (ts == null) {
    return "-";
  }
  return new Time(ts).Format("YYYY/MM/dd");
}

export function formatDateTime(ts: number | null | undefined): string {
  if (ts == null) {
    return "-";
  }
  return new Time(ts).Format("YYYY/MM/dd HH:mm:ss");
}

// 秒 → HH:MM:SS。
export function formatHMS(totalSeconds: number | null | undefined): string {
  if (totalSeconds == null) {
    return "-";
  }
  const seconds = Math.max(0, Math.floor(totalSeconds));
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${pad(Math.floor(seconds / 3600))}:${pad(Math.floor((seconds % 3600) / 60))}:${pad(seconds % 60)}`;
}
